
// Sample Config
// export default {
//     apiGateway: {
//         URL: 'https://0o71l52g6f.execute-api.us-east-1.amazonaws.com/dev'
//     },
//     cognito: {
//         USER_POOL_ID : 'us-east-1_myjNZkr1B',
//         APP_CLIENT_ID : '181jugii1m16go2eh9555ul02d'
//     },
//     fineUploader: {
//         endpointURL: 'https://oas-s3-k2wpjou7ktmz-inputs3-179oew1kcv45h.s3.amazonaws.com',
//         endpointAccessKey: "AKIAI2SMTOUPMNTOSO6Q",
//         endpointRegion: "us-east-1"
//     },
//     externalURL:{
//         wwwURL: "www.riverbedoas.name",
//         sfdcURL: "https://customersuccess.riverbed.com/#/views/Refresh/RefreshAccounts?:embed=yes&:linktarget=_self",
//         splunkURL: "https://splunk.riverbedoas.name",
//         supportURL: "https://riverbedoas.freshservice.com/support/login",
//         SSO_URL : 'riverbedoas-dev.auth.us-east-1.amazoncognito.com'
//     }
// }

// Values will be populated by CloudFormation Lambda deployment function or CI
export default {
    apiGateway: {
        URL: "https://api.riverbedoas.com",
    },
    cognito: {
        USER_POOL_ID : "us-east-1_oXIR5JKQ0",
        APP_CLIENT_ID : "7saqgt7rs9srdc22najgqa02gu",
        SAML_PROVIDER: "Riverbed"
    },
    fineUploader: {
        endpointURL: "https://oas-s3-g5gl5xc0hhm6-inputs3-h0ucako4xxnz.s3.amazonaws.com",
        endpointAccessKey: "AKIAI57OBNMFO2YLAQYA",
        endpointRegion: "us-east-1"
    },
    externalURL:{
        wwwURL: "www.riverbedoas.com",
        sfdcURL: "https://customersuccess.riverbed.com/#/views/Refresh/RefreshAccounts?:embed=yes&:linktarget=_self",
        splunkURL: "https://splunk.riverbedoas.com",
        supportURL: "https://support.riverbedoas.com/login/sso",
        SSO_URL: "riverbedoas.auth.us-east-1.amazoncognito.com"
    },
    site: {
        version: "1.2.5-prod",
        build: "d3727dd"
    },
    ui: {
        reportsRestricted: 1
    }
};


// WEBPACK FOOTER //
// ./src/config.js